import TweenMax from 'gsap';

const homepageSlider = jQuery('#homepageSlider');
jQuery(document).ready(function() {
  homepageSlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    autoplay: false,
    dots: false,
    focusOnSelect: true,
    infinite: false,
    rows: 0,
    speed: 2000,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          speed: 500,
        }
      }
    ]
  });
});

var curr = 0;
var next = 0;

// Progress bar
$(document).ready(function() {
  var $slider = $('#homepageSlider');
  var $progressBar = $('.progress');
  var $progressBarLabel = $( '.slider__label' );

  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide ) / (slick.slideCount) ) * 100;
    // console.log(calc);
    calc = calc + (18 * nextSlide);

    curr = currentSlide;
    next = nextSlide;
    
    $progressBar
      // .css('background-size', calc + '% 100%')
      // .css('background-position', 'left ' + calc + '%')
      .css('background-position', calc + '%')
      .attr('aria-valuenow', calc );
  });
});

let blocked = false;
let blockTimeout = null;
let prevDeltaY = 0;

// Parallax
$(".parallax").mousemove(function(e) {
  parallaxIt(e, ".mega", 35);
  parallaxIt(e, ".tele", 35);
  parallaxIt(e, ".midi", 22);
});

function parallaxIt(e, target, movement) {
  var $this = $(".parallax");

  var relX = e.pageX  - $this.offset().left;
  var relY = e.pageY - $this.offset().top;

  TweenMax.to(target, 1, {
    // Default
    x: (relX - $this.width() / 2) / $this.width() * movement - 10,
    y: (relY - $this.height() / 2) / $this.height() * movement
  });
}

// var scrollCount = null;
// var scroll = null;
// homepageSlider.on('wheel', (function(e) {
//   e.preventDefault();

//   clearTimeout(scroll);
//   scroll = setTimeout(function(){scrollCount=0;}, 200);
//   if(scrollCount) return 0;
//   scrollCount = 1;


//   if (e.originalEvent.deltaY < 0) {
//     e.preventDefault();
//     $(this).slick('slickPrev');
//   } else {
//     e.preventDefault();

//     var slideCount = $(this)[0].slick["slideCount"];
//     var currentIndex = $(this).slick("slickCurrentSlide");
//     var homepageSliderHeight = jQuery('#homepageSlider').height();
//     if (slideCount == (currentIndex + 1)) {
//       $('html,body').animate({
//         scrollTop: '+=' + homepageSliderHeight + 'px'
//       }, 1);
//     }

//     $(this).slick('slickNext');
//   }
// }));

jQuery('.homepage-banner .arrow-container').on('click', function() {
  var homepageSliderHeight = jQuery('#homepageSlider').height();
  jQuery('html,body').animate({
    scrollTop: '+=' + homepageSliderHeight + 'px'
  }, 1);
});
jQuery(document).ready(function() {
jQuery('.homepage-banner #homepageSlider .slick-slide .tv, .homepage-banner #homepageSlider .slick-slide .tv-button').click(function() {
  // var id = jQuery(this).attr('data-slick-index');  
  var id = jQuery(this).closest('.slick-slide').attr('data-slick-index');

  var link = jQuery('.homepage-banner #homepageSlider .slick-slide[data-slick-index="'+id+'"] .homepage-slider-link').attr('href');
  // hide the other slides
  // jQuery('.homepage-banner #homepageSlider .slick-slide:not([data-slick-index="'+id+'"])').hide();
  // jQuery('.homepage-banner #homepageSlider .slick-track').css('transform', 'translate3d(0px, 0px, 0px)');

  // scroll to top of slider
  // var offset = jQuery('.homepage-banner #homepageSlider').offset();
  // jQuery('html, body').animate({
  //     scrollTop: offset.top - 120
  // }, 5);

  // fade out progress bar
  setTimeout(function() {
    jQuery('.homepage-banner .progress').fadeOut(500);
  }, 100);

  // fade out arrow-container
  setTimeout(function() {
    jQuery('.homepage-banner .arrow-container').fadeOut(500);
  });

  // fade out slide content e.g. title
  setTimeout(function() {
    jQuery('.homepage-banner #homepageSlider .slick-slide .content').fadeOut(500);
  }, 200);

  // fade out foreground
  setTimeout(function() {
    jQuery('.homepage-banner #homepageSlider .slick-slide .foreground').fadeOut(500);
  }, 300);

  // fade out tv-button
  setTimeout(function() {
    jQuery('.homepage-banner #homepageSlider .slick-slide .tv-button').fadeOut(500);
  }, 300);

  // fade out middle
  setTimeout(function() {
    jQuery('.homepage-banner #homepageSlider .slick-slide .middle').fadeOut(500);
  }, 500);
  // fade out middle
  setTimeout(function() {
    jQuery('.homepage-banner #homepageSlider .slick-slide .background').fadeOut(300);
  }, 700);

  // zoom in
  setTimeout(function() {
    if (jQuery(window).width() > 1500) {
      // jQuery('.homepage-banner #homepageSlider .slick-slide[data-slick-index="'+id+'"] .tv').transition({ scale: 1.2, x: -390, y: -10, width: '1050px', height: '500px' }, 400);
      // jQuery('.homepage-banner #homepageSlider .slick-slide[data-slick-index="'+id+'"] .tv').transition({ scale: 1.2, x: -390, y: -10, width: '1050px', height: '480px' }, 400);
      jQuery('.homepage-banner #homepageSlider .slick-slide[data-slick-index="'+id+'"] .tv').transition({ scale: 1.2, x: -420, y: -10, width: '1100px', height: '480px' }, 400);
    } else if ((jQuery(window).width() > 1201) && (jQuery(window).width() < 1499)) {
      // MACBOOK
      jQuery('.homepage-banner #homepageSlider .slick-slide[data-slick-index="'+id+'"] .tv').css('maxHeight','600px');
      
      jQuery('.homepage-banner #homepageSlider .slick-slide[data-slick-index="'+id+'"] .tv').transition({  x: '-37.3%', y: '10px', height: '600px', width: '1248px' }, 800);
    } else if ((jQuery(window).width() < 1200) && (jQuery(window).width() > 900)) {
      // SMALL
      jQuery('.homepage-banner #homepageSlider .slick-slide[data-slick-index="'+id+'"] .tv').transition({ scale: 1.2, x: '-50%', height: '600px', width: '100%' }, 400);
    } else {
      // do nothing
    }
  }, 200);

  // go to case study page
  setTimeout(function() {
    window.location.href = link;
  }, 1000);
});
});

jQuery(document).ready(function() {
  if (window.location.pathname == '/') {
    jQuery('#homepageSlider').fadeIn(1000);
  }
});

// if ( window.location.pathname == '/' ) {
//   var lastScrollTop = 0;
//   jQuery(window).bind("scroll", function(e) {
//     var myElement = document.getElementById('homepageBanner');
//     var bounding = myElement.getBoundingClientRect();
//     var st = jQuery(this).scrollTop();

//     if (st < lastScrollTop) {
//       if (bounding.bottom >= 0) {
//         jQuery("html, body").animate({ scrollTop: 0 }, "fast");
//         // jQuery(window).unbind('scroll');
//         // jQuery('header').removeClass('scroll');
//       }
//     }

//     lastScrollTop = st;

//   });
// }